module.exports = __webpack_public_path__ + "index/img/home.7cffb771.png";